<template>
  <div id="app">
    <top-nav v-if="showNav" />
    <div class="app-main">
      <router-view />
    </div>
    <site-footer v-if="showFooter" />
    <wechat-float />
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import WechatFloat from '@/components/WechatFloat.vue'

function readSearchParams() {
  try {
    return new URLSearchParams(window.location.search || '')
  } catch {
    return new URLSearchParams()
  }
}

export default {
  name: 'App',
  components: { TopNav, SiteFooter, WechatFloat },
  computed: {
    showNav() {
      return this.$route.name !== 'Login' && this.$route.name !== 'Register'
    },
    showFooter() {
      const path = this.$route.path
      return !path.startsWith('/admin') &&
        this.$route.name !== 'Login' &&
        this.$route.name !== 'Register'
    }
  },
  created() {
    // 支付宝 return_url 参数常落在 location.search（# 之前），hash 路由读不到，这里统一导回文章页
    this.consumeAlipayReturn()
  },
  methods: {
    consumeAlipayReturn() {
      const sp = readSearchParams()
      const type = sp.get('type')
      const orderId = sp.get('orderId')
      if (type !== 'att' || !orderId) return

      const email = sp.get('email') || ''
      const reportId = sp.get('reportId') || ''
      if (email) localStorage.setItem('att_guest_email', email)
      localStorage.setItem('att_pending_order_id', String(orderId))

      const targetReportId = reportId || (this.$route.path.startsWith('/research/')
        ? this.$route.params.id
        : '')
      if (!targetReportId) return

      // 清掉 search，避免刷新重复跳转；把参数交给 hash 路由
      const cleanUrl = `${window.location.origin}${window.location.pathname}#/research/${targetReportId}` +
        `?type=att&orderId=${encodeURIComponent(orderId)}` +
        (email ? `&email=${encodeURIComponent(email)}` : '')
      window.history.replaceState(null, '', cleanUrl)
      if (this.$route.fullPath !== `/research/${targetReportId}?type=att&orderId=${orderId}`) {
        this.$router.replace({
          path: `/research/${targetReportId}`,
          query: { type: 'att', orderId, ...(email ? { email } : {}) }
        })
      }
    }
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.app-main {
  flex: 1;
}
</style>
